import { createAction } from 'redux-actions';
export const SET_TRAVELLERS = 'ORDER/SET_TRAVELLERS';
export const setTravellers = createAction(SET_TRAVELLERS);
